<template>
    <form id="pricing-form" autocomplete="off" class="w-full bg-white py-0 transition-all duration-300 max-h-0 opacity-0 active-component"
        enctype="multipart/form-data">
        <div class="flex flex-col gap-y-4 pb-6">
            <div class="flex flex-col lg:flex-row gap-4">
                <div class="relative w-full lg:w-1/2 pt-[15px] pb-[16px] lg:pt-[18px] lg:pb-[19px]">
                    <input ref="noName" v-model="inpName" type="text" id="inp-yourname" class="font-medium body-1 leading-[22.4px] text-black border-b w-full px-0 py-4 lg:py-1 border-t-0 border-l-0 border-r-0 
                        focus:outline-none focus:ring-0 focus:border-black peer"
                        :class="!validation_name ? 'border-b-[#BF4A5E]' : 'border-b-[#D3D4D8]'" autocomplete="off"
                        @blur="checkNameValidate" @key-up="updateInput">
                    <label id="email-label" for="inp-yourname"
                        class="absolute left-0 top-[15px] lg:top-[18px] transition-all duration-200 transform cursor-text text-black tracking-[0.32px] 
                        peer-focus:tracking-[0.24px] peer-focus:text-xs peer-focus:-translate-y-full peer-focus:text-[#D3D4D8]"
                        :class="inpName !== '' ? 'tracking-[0.24px] text-xs -translate-y-full text-[#D3D4D8]' : ''">
                        Your name <span class="text-[#BF4A5E]">*</span></label>
                    <transition>
                        <span v-if="!validation_name"
                            class="absolute top-0 right-0 transform translate-y-full text-[14px] text-[#BF4A5E]">Required
                            field.</span>
                    </transition>
                </div>
                <div class="relative w-full lg:w-1/2 pt-[15px] pb-[16px] lg:pt-[18px] lg:pb-[19px]">
                    <input v-model="inpCompany" type="text" id="inp-company"
                        class="font-medium body-1 leading-[22.4px] text-black border-b w-full px-0 py-4 lg:py-1 border-b-[#D3D4D8] border-t-0 border-l-0 border-r-0 focus:outline-none focus:ring-0 focus:border-black peer"
                        autocomplete="off">
                    <label for="inp-company"
                        class="absolute left-0 top-[15px] lg:top-[18px] transition-all duration-200 transform cursor-text text-black tracking-[0.32px] 
                        peer-focus:tracking-[0.24px] peer-focus:text-xs peer-focus:-translate-y-full peer-focus:text-[#D3D4D8]"
                        :class="inpCompany !== '' ? 'tracking-[0.24px] text-xs -translate-y-full text-[#D3D4D8]' : 'translate-y-0'">
                        Company <span class="text-[#D3D4D8]">(Optional)</span></label>
                </div>
            </div>
            <div class="relative w-full pt-[15px] pb-[16px] lg:pt-[18px] lg:pb-[19px]">
                <input ref="noEmail"  v-model="inpEmail" type="email" id="inp-email"
                    class="font-medium body-1 leading-[22.4px] text-black border-b w-full px-0 py-4 lg:py-1 border-t-0 border-l-0 border-r-0 focus:outline-none focus:ring-0 focus:border-black peer"
                    :class="!validation_email ? 'border-b-[#BF4A5E]' : 'border-b-[#D3D4D8]'" autocomplete="off"
                    @blur="checkEmailValidate" @key-up="updateInput">
                <label for="inp-email"
                    class="absolute left-0 top-[15px] lg:top-[18px] transition-all duration-200 transform cursor-text text-black tracking-[0.32px] 
                    peer-focus:tracking-[0.24px] peer-focus:text-xs peer-focus:-translate-y-full peer-focus:text-[#D3D4D8]"
                    :class="inpEmail !== '' ? 'tracking-[0.24px] text-xs -translate-y-full text-[#D3D4D8]' : 'translate-y-0'">
                    Email <span class="text-[#BF4A5E]">*</span></label>
                <transition>
                    <span v-if="!validation_email"
                        class="absolute top-0 right-0 transform translate-y-full text-[14px] text-[#BF4A5E]">Required
                        field.</span>
                </transition>
                <transition>
                    <span v-if="verified_email !== '' & verified_email === 'verified'"
                        class="absolute top-0 right-0 transform translate-y-1/2 h-6 w-6 flex items-center justify-center rounded-full border border-[#388048] text-[#388048] email-verified">
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.951416 3.58006L4.59698 7.22569L11.0487 0.774005" stroke="#388048" stroke-width="1.5" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </transition>
              
            </div>
            <div class="relative w-full pt-[15px] pb-[16px] lg:pt-[18px] lg:pb-[19px]">
                <textarea ref="yesEmail" v-model="inpMessage" id="inp-message" class="font-medium body-1 leading-[22.4px] text-black max-lg:min-h-[57px] border-b w-full h-auto px-0 py-[18px] lg:py-1 overflow-y-hidden border-b-[#D3D4D8] border-t-0 border-l-0 border-r-0 
                    focus:outline-none focus:ring-0 focus:border-black peer" rows="1"></textarea>
                <label for="inp-message"
                    class="absolute left-0 top-[15px] lg:top-[18px] transition-all duration-200 transform cursor-text text-black tracking-[0.32px] 
                    peer-focus:tracking-[0.24px] peer-focus:text-xs peer-focus:-translate-y-full peer-focus:text-[#D3D4D8]"
                    :class="inpMessage !== '' ? 'tracking-[0.24px] text-xs -translate-y-full text-[#D3D4D8]' : 'translate-y-0'">
                    Message <span class="text-[#D3D4D8]">(Optional)</span></label>
            </div>
            <div class="relative w-full max-lg:mt-1">
                <transition>
                    <div class="flex gap-2 flex-wrap pb-4" v-if="files.length > 0">
                        <p class="btn icon-leading h-fit text-[14px] ico border border-[#D3D4D8] font-normal rounded-full px-4 py-[10px] flex gap-2 items-center leading-normal"
                            :class="getFileExt(file.name)" v-for="(file, index) in files" :key="index">
                            {{file.name}}
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                xmlns="http://www.w3.org/2000/svg" @click="removeFileUpload(index)"
                                class="hover:cursor-pointer">
                                <path d="M1 1L9 9" stroke="#A1A4AC" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M9 1L1 9" stroke="#A1A4AC" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </p>
                    </div>
                </transition>
                <span
                    class="btn rounded-full border border-[#D3D4D8] bg-white text-[14px] text-[#020B1F] icon-leading ico ico__attachment hover:cursor-pointer px-4 h-[36px]
                    transition-all duration-300 hover:transition-all hover:duration-300 hover:scale-105 btn-attachment"
                    @click="showFileUpload">
                    Attach a file
                </span>
                <input ref="fileUpload" id="inp-file" type="file" @change="onFileChenged" class="opacity-0 h-0 w-0"
                    multiple="multiple">
            </div>
            <div class="relative w-full max-lg:mt-1">
                <label for="inp-NDA"
                    class="checkbox-group flex gap-2 items-center rounded-full w-fit bg-white border-0 border-transparent transition-all duration-300">
                    <input type="checkbox" id="inp-NDA" v-model="inpNda">
                    <span>Do you require an NDA?</span>
                </label>
            </div>
        </div>

        <div class="pt-5 pb-5 flex w-full gap-6 items-center">
            <div class="flex items-center max-lg:gap-4">
                
                <button
                    class="btn max-lg:icon-only btn__primary max-lg:icon-trailing max-lg:ico max-lg:ico__arrow_point_right text-[16px] leading-[24px] lg:px-10 min-w-[48px] h-[48px] justify-center items-center"
                    style="line-height: normal;" @click="confirmEmail"><span
                        class="max-lg:hidden">Submit</span></button>
                <button id="btn-submitOrder"
                    class="hidden" @click="formSubmited"><span
                        class="max-lg:hidden">Submit</span></button>
            </div>

            <div class="w-fit flex gap-[6px]">
                <p class="body-1 leading-[22.4px] font-medium text-[#6D727E] tracking-[0.32px]"
                :class="{'hidden' : selectedPeriod && selectedPeriod.label === '3 Days Trial'}">Estimated cost</p>
                <p class="body-1 font-semibold leading-[141.667%]">${{moneyFormatUSA(subtotal)}}
                    <span v-if="selectedPeriod !== null && selectedPeriod.minimalBooking >= 2 && selectedPeriod.label !== '3 Days Trial'" class="text-[14px] text-black">/month</span>
                    <span v-if="selectedPeriod !== null && selectedPeriod.minimalBooking < 2" class="text-[14px] text-black">/week</span>
                    <span v-if="selectedPeriod !== null && selectedPeriod.minimalBooking >= 2 && selectedPeriod.label === '3 Days Trial'" class="text-[14px] text-black">/3 days</span>
                    <template v-if="total > 0 && selectedPeriod !== null && selectedPeriod.discount > 0">
                        <span
                            class="text-[14px] text-[#454B57] font-medium lg:pl-[6px] line-through hidden lg:inline">${{moneyFormatUSA(total)}}</span>
                    </template>
                </p>
                <template v-if="total > 0 && selectedPeriod !== null && selectedPeriod.discount > 0">
                    <p class="text-[14px] text-[#454B57] font-medium lg:pl-[6px] line-through lg:hidden">
                        ${{moneyFormatUSA(total)}}</p>
                </template>
            </div>
        </div>

        <div class="" v-if="subtotal > 0">
            <div class="px-4 py-[15px] border border-[#CBD4EC] rounded-[20px] flex gap-[10px]">
                <div
                    class="w-fit h-fit max-lg:p-2 lg:w-9 lg:h-9 flex items-center justify-center rounded-full bg-[#EAEDF7]">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.238 17.9997H4.8818C3.04085 17.9997 1.54846 16.5073 1.54846 14.6664V14.2217H11.8391"
                            stroke="#0F39A6" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M11.8389 14.2198L11.8385 15.6929C11.8381 16.967 12.8708 18 14.1449 18V18C15.4187 18 16.4513 16.9674 16.4513 15.6936V3.36616C16.4513 3.16411 16.2875 3.00031 16.0855 3.00031L4.67571 3.00001C4.44559 3 4.25903 3.18655 4.25903 3.41668V14.2198"
                            stroke="#0F39A6" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.85522 6.3335H12.8552" stroke="#0F39A6" stroke-width="1.08333" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M7.85522 8.8335H12.8552" stroke="#0F39A6" stroke-width="1.08333" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M7.85522 11.3335H10.3552" stroke="#0F39A6" stroke-width="1.08333"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="flex flex-col gap-1">
                    <p
                        class="text-[14px] lg:text-[16px] font-medium leading-[19.36px] tracking-[0.16px] text-[#020B1F]">
                        This is only an estimation!</p>
                    <p class="text-[13px] lg:text-[14px] leading-[22px] tracking-[0.14px] text-[#454B57]">You can talk
                        to us first and negotiate to find your best price</p>
                </div>
            </div>
        </div>
    </form>
     
</template>
<script>
    import {
        isProxy,
        toRaw
    } from 'vue';

    export default {
        props: {
            subtotal: {
                type: Number,
                default: 0
            },
            total: {
                type: Number,
                default: 0
            },
            selectedServices: {
                type: Array,
                default: []
            },
            selectedPeriod: {
                type: Object,
                default: {}
            },
            inputName:{
                type: Boolean,
                default:true,
            },
            inputEmail:{
                type: Boolean,
                default:true,
            }
        },
        data() {
            return {
                inpName: '',
                inpCompany: '',
                inpEmail: '',
                inpMessage: '',
                elTextarea: null,
                files: [],
                inpNda: false,
                validation_name: true,
                validation_email: true,
                validation_service: true,
                validation_period: true,
                valid_send_data: false,
                verified_email: ''
            }
        },
        methods: {
         setFocusTo(refName) {
            this.$refs[refName]?.focus();
            },
                confirmEmail(e){
                    e.preventDefault();
                        if (this.selectedServices !== '' && this.selectedPeriod !== null) {
                            this.$emit('emailNotVerified');
                        } else {
                            if (this.selectedServices == '') {
                            this.$emit('validateService', false);
                            }
                            if (this.selectedPeriod === null) {
                            this.$emit('validatePeriod', false);
                            }
                        }
                },
            formSubmited(e) {
                e.preventDefault();

                if (this.inpName === '') {
                    this.validation_name = false;
                    this.valid_send_data = false;
                }

                if (this.inpEmail === '') {
                    this.validation_email = false;
                    this.valid_send_data = false;
                }


                if (this.validation_name && this.validation_email) {
                    this.valid_send_data = true;
                } else {
                    this.valid_send_data = false;
                }

                let rawData = this.files;

                if (isProxy(this.files)) {
                    rawData = toRaw(this.files)
                }
                this.$emit('submited', [
                    this.inpName,
                    this.inpCompany,
                    this.inpEmail,
                    this.inpMessage,
                    this.files.length,
                    this.inpNda,
                    this.valid_send_data,
                    this.verified_email
                ]);

            },
            onFileChenged(events) {
         
                this.addImageToList('inp-file')
                this.files = [];
                for (let index = 0; index < this.getImageFileLists().length; index++) {
                    const element = this.getImageFileLists()[index];
                    let file = {
                        name: element.name,
                        type: element.type
                    }
                    this.files.push(file);
                }
                const inputFile = document.getElementById('inp-file');
            },
            showFileUpload() {
                this.$refs.fileUpload.click();
            },
            checkNameValidate() {
                if (this.inpName !== '') {
                    this.validation_name = true;
                } else {
                    this.validation_name = false;
                }
            },
            checkEmailValidate() {
                if (this.inpEmail !== '') {
                    const list = ['outlook.com', 'gmail.com', 'yahoo.com', 'inbox.com', 'icloud.com', 'mail.com',
                        'gmx.com', 'zohomail.com', 'yandex.com', 'protonmail.com', 'aol.com', 'tutanota.com'
                    ];
                    let str = this.inpEmail
                    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    if (str.match(validRegex)) {
                        let splitEmail = this.inpEmail.split('@');
                        
                        for (let index = 0; index < list.length; index++) {
                            if (splitEmail[1] === list[index]) {
                                this.verified_email = 'verified';
                                this.$emit('inputValue',this.inpEmail);
                                this.$emit('inputName',this.inpName);
                                return;
                            }
                        }
                        this.verified_email = 'not-verified';
                        //   this.$emit('emailNotVerified');
                          this.$emit('inputValue',this.inpEmail);
                          this.$emit('inputName',this.inpName);
                        this.validation_email = true;
                        return;
                    } else {
                        this.validation_email = false;
                        //   this.$emit('emailNotVerified');
                           this.$emit('inputValue',this.inpEmail);
                           this.$emit('inputName',this.inpName);
                        this.verified_email = 'not-verified';
                        return;
                    }
                } else {
                    this.validation_email = false;
                    this.verified_email = 'not-verified';
                }
            },
            updateInput() {
                if (this.inpName !== '') {
                    this.validation_name = true;
                }
                if (this.inpEmail !== '') {
                    this.validation_email = true;
                }
            },
            removeFileUpload(index) {
                this.removeImageFromList('inp-file', index)
                this.files = [];
                for (let index = 0; index < this.getImageFileLists().length; index++) {
                    const element = this.getImageFileLists()[index];
                    let file = {
                        name: element.name,
                        type: element.type
                    }
                    this.files.push(file);
                }
            },

            getFileExt(filename) {
                let ext = 'file'
                if (filename.toLowerCase().endsWith(".pdf")) {
                    ext = 'ico__file-pdf';
                } else if (filename.toLowerCase().endsWith(".jpg") || filename.toLowerCase().endsWith(".jpeg")) {
                    ext = 'ico__file-jpg';
                } else if (filename.toLowerCase().endsWith(".png")) {
                    ext = 'ico__file-png';
                } else if (filename.toLowerCase().endsWith(".svg")) {
                    ext = 'ico__file-svg';
                } else if (filename.toLowerCase().endsWith(".doc") || filename.toLowerCase().endsWith(".docx")) {
                    ext = 'ico__file-doc';
                } else if (filename.toLowerCase().endsWith(".ppt") || filename.toLowerCase().endsWith(".pptx")) {
                    ext = 'ico__file-ppt';
                } else if (filename.toLowerCase().endsWith(".csv") || filename.toLowerCase().endsWith(".xls") || filename.toLowerCase().endsWith(".xlsx") || filename.toLowerCase().endsWith(".xml")) {
                    ext = 'ico__file-xls';
                }else if (filename.toLowerCase().endsWith(".rar")) {
                    ext = 'ico__file-rar';
                }else if (filename.toLowerCase().endsWith(".zip")) {
                    ext = 'ico__file-zip';
                }else {
                    ext = 'ico__attachment';
                }
                return ext;
            }
        },
        mounted() {
            this.elTextarea = document.getElementById('inp-message');
        },

        watch: {
            inpMessage: {
                handler(e) {
                    if (!this.elTextarea) {
                        this.elTextarea = document.getElementById('inp-message');
                    }
                    if (this.elTextarea) {
                        if (e !== '') {
                            this.elTextarea.style.height = this.elTextarea.scrollHeight + 'px';
                        } else {
                            this.elTextarea.style.height = '32.88px';
                        }
                    }
                }
            },
            inpName: {
                handler() {
                    if (this.inpName !== '') {
                        this.validation_name = true;
                    } else {
                        this.validation_name = false;
                    }
                }
            },
            inpEmail: {
                handler() {
                    if (this.inpEmail !== '') {
                        this.validation_email = true;
                    } else {
                        this.validation_email = false;
                        this.verified_email = 'not-verified';
                    }
                }
            }
        },


    }
</script>
<style lang="scss" scoped>
    .active-component {
        @apply max-h-[100000px] opacity-100 pt-8;
    }
    .btn-attachment{
        &::before{
            @apply pt-[3px];
        }
    }
</style>